export default __webpack_public_path__ + "static/media/inline-sparkle.fd57f5da.svg";